// @flow
export { default } from './UserAboutEdit';



// WEBPACK FOOTER //
// ./src/components/user/UserAboutEdit/index.js